<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row">
      <div class="col-md-12">
        <appQuantitySelectionContainer></appQuantitySelectionContainer>
        <appPersonalizationButton></appPersonalizationButton>
        <appAddToCartButton
          v-show="getPersonalizationStatus"
        ></appAddToCartButton>
      </div>
    </div>
  </div>
</template>
<script>
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(usePersonalizeStore, ["getPersonalizationStatus"])
  }
};
</script>
